import restClient from "../restClient";

const authConfig = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem("token")}`,
  },
});

export const sendBulkSmsToCustomers = async ({ customer_ids, selection, message }) => {
  const response = await restClient.post(
    "sms-service/customers/bulk-send",
    { customer_ids, selection, message },
    authConfig()
  );
  return response.data;
};
